export type QuoteServiceAssignment = {
  id: string;
  referenceId?: string | null;
};

/**
 * Apply a schedule's service assignment ledger to member service clones.
 * An empty assignment remains the legacy "all services" state.
 */
export function filterQuoteServicesForSchedule<
  T extends QuoteServiceAssignment,
>(services: T[], assignedServiceIds: ReadonlyArray<string>): T[] {
  if (assignedServiceIds.length === 0) return services;

  const assignedIds = new Set(assignedServiceIds);
  return services.filter(
    (service) =>
      assignedIds.has(service.id) ||
      Boolean(service.referenceId && assignedIds.has(service.referenceId)),
  );
}
